import { Close, LinkTwoTone } from '@material-ui/icons';
import React from 'react';
import { ActionButton, ActionButtonsContainer, CommittePackageName, PackageBox, PackageCommitteLink, PackageListContainer } from './styles';

export interface ICommittee {
  name: string;
  id: string;
}

interface ICommitteesListProps {
  committees: ICommittee[];
  handleRemoveCommittee: (committeeToDeleteId: string) => Promise<void>;
}

const CommitteesList = ({committees, handleRemoveCommittee}: ICommitteesListProps) => {
  return (
    <PackageListContainer>
      {committees.map((committee) => (
        <PackageBox key={committee.id}>
          <CommittePackageName>
            {committee.name}
          </CommittePackageName>
          

          <ActionButtonsContainer>
            <PackageCommitteLink href={`/system-management/configure-committees?id=${committee.id}`} target="_blank">
              <LinkTwoTone />
            </PackageCommitteLink>
            
            <ActionButton onClick={() => handleRemoveCommittee(committee.id)}>
              <Close />
            </ActionButton>
          </ActionButtonsContainer>
        </PackageBox>        
      ))}
    </PackageListContainer>      
  );
};

export default CommitteesList;